import { render, staticRenderFns } from "./StartNewSearchPage.vue?vue&type=template&id=6ef86e24&"
import script from "./StartNewSearchPage.vue?vue&type=script&lang=ts&"
export * from "./StartNewSearchPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports